module.exports = __webpack_public_path__ + "img/logo_untrr.a1c5f5c3.png";